import { BUSINESS_UNIT_DROPDOWN_OPTION, CAMPAIGN, CONTACT, OWNER, SUBMISSION_TAG, USER, COMMENT
// @ts-expect-error: no types
} from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error: no types
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-expect-error: no types
import BusinessUnitDropdownReferenceResolver from 'reference-resolvers/resolvers/BusinessUnitDropdownReferenceResolver';
// @ts-expect-error: no types
import CampaignReferenceResolver from 'reference-resolvers/resolvers/CampaignReferenceResolver';
// @ts-expect-error: no types
import ContactReferenceResolver from 'reference-resolvers/resolvers/ContactReferenceResolver';
// @ts-expect-error: no types
import OwnerReferenceResolver from 'reference-resolvers/resolvers/OwnerReferenceResolver';
// @ts-expect-error: no types
import SubmissionTagReferenceResolver from 'reference-resolvers/resolvers/SubmissionTagReferenceResolver';
// @ts-expect-error: no types
import UserReferenceResolver from 'reference-resolvers/resolvers/UserReferenceResolver';
// @ts-expect-error: no types
import CommentCountReferenceResolver from 'reference-resolvers/resolvers/CommentCountReferenceResolver';
const resolvers = {
  [BUSINESS_UNIT_DROPDOWN_OPTION]: BusinessUnitDropdownReferenceResolver,
  [CAMPAIGN]: CampaignReferenceResolver,
  [CONTACT]: ContactReferenceResolver,
  [OWNER]: OwnerReferenceResolver,
  [USER]: UserReferenceResolver,
  [COMMENT]: CommentCountReferenceResolver,
  [SUBMISSION_TAG]: SubmissionTagReferenceResolver
};
export default ProvideReferenceResolvers(resolvers);